module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("camkZ"))).then(() => parcelRequire('5erN3'));